import { Navigate, type RouteObject } from "react-router";
import type { AppModule, ShellContext } from "../types";

const routes: RouteObject[] = [
  {
    path: "/approvals",
    handle: { title: "Approvals" },
    lazy: () => import("./pages/ApprovalsPage").then((m) => ({ Component: m.ApprovalsPage })),
  },
  {
    path: "/approvals/details/:approvalRequestId",
    handle: { title: "Approvals" },
    lazy: () => import("./pages/RequestDetailPage").then((m) => ({ Component: m.RequestDetailPage })),
  },
  {
    path: "/approvals/:approvalType",
    handle: { title: "Approvals" },
    lazy: () => import("./pages/ApprovalsPage").then((m) => ({ Component: m.ApprovalsPage })),
  },
  // Clockify Free redirects to its promo page; the clone has none, so copied links land on the real page (routes.md).
  { path: "/promo/approvals", element: <Navigate replace to="/approvals#pending" /> },
];

function enabled(settings: Record<string, unknown>, key: string): boolean {
  const v = settings[key];
  return typeof v === "object" && v !== null && (v as { approvalEnabled?: unknown }).approvalEnabled === true;
}

/** Owner/Admin always; managers only while time or expense approval is on (approvals.md 3). */
export function approvalsVisible(ctx: ShellContext): boolean {
  if (ctx.isAdmin) return true;
  const managerRole = ctx.role === "TEAM_MANAGER" || ctx.role === "PROJECT_MANAGER";
  return (
    managerRole &&
    (enabled(ctx.workspaceSettings, "approvalSettings") || enabled(ctx.workspaceSettings, "expenseApprovalSettings"))
  );
}

export const approvalsModule: AppModule = {
  name: "approvals",
  routes: { shell: routes },
  sidebar: [
    {
      id: "APPROVALS",
      label: "Approvals",
      path: "/approvals#pending",
      icon: "approvals",
      visible: approvalsVisible,
      activePrefixes: ["/approvals"],
      alt: "View Approvals",
    },
  ],
};
